//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NewEvent from "@/components/objects/public/object-snippets/NewEvent.vue"
import MainShowMoreBtn from '@/components/MainShowMoreBtn.vue';

export default {
  name: "MainEvents",
  components: { NewEvent, MainShowMoreBtn },

  data() {
    return {
      slicedEvents: [],
      eventsViewCount: 4,
      swapedBtnToLink: false,
    }
  },

  computed: {
    mainEvents() {
      return this.$store.getters['objects/getMainEvents'];
    }
  },

  watch: {
    eventsViewCount(newVal) {
      this.slicedEvents = this.mainEvents.slice(0, newVal)

      this.swapedBtnToLink = false
    },
  },

  mounted(){
    this.updateEventsViewCount()
    this.slicedEvents = this.mainEvents.slice(0, this.eventsViewCount)

    window.addEventListener('resize', this.updateEventsViewCount, { passive: true })
  },

  destroyed() {
    window.removeEventListener('resize', this.updateEventsViewCount)
  },

  methods: {
    updateEventsViewCount() {
      if (typeof window !== "undefined") {
        if (window.innerWidth >= 1600 ) {
          this.eventsViewCount = 8
        } else if (window.innerWidth >= 1200) {
          this.eventsViewCount = 6
        } else if (window.innerWidth >= 640) {
          this.eventsViewCount = 4
        } else {
          this.eventsViewCount = 6
        }
      }
    },

    addMoreEvents() {
      this.slicedEvents = this.mainEvents.slice(0, this.eventsViewCount + (window.innerWidth < 640 ? 3 : this.eventsViewCount / 2))
      this.swapedBtnToLink = true
    }
  }
}
